



























import { defineComponent, watch, toRef, ref, computed } from '@vue/composition-api';
import { useStore } from '@/store';

interface PropsInterface {
    isOpened: boolean;
    title: string;
    isNotPrintable: boolean;
}

export default defineComponent({
    name: 'VehicleAccordion',
    props: {
        isOpened: { type: Boolean, required: true },
        title: { type: String, required: true },
        isNotPrintable: { type: Boolean, required: false }
    },
    setup (props: PropsInterface) {
        const isOpened = toRef(props, 'isOpened');
        const isBordered = ref(!isOpened.value);
        const store = useStore();
        const hasComparingItems = computed(() => store.getters.notEmptyComparingItems.length);
        const isLastColumnHidden = computed(() => store.getters.isLastColumnHidden);

        watch(isOpened, (value) => {
            if (value) {
                isBordered.value = false;
            }
        });

        const drawBorder = () => {
            isBordered.value = true;
        };
        return { isBordered, drawBorder, hasComparingItems, isLastColumnHidden };
    }
});
